export default {
  setTokensListState(context, list) {
    context.list = list;
  },
  mutateTokensLoadingState(context, loading) {
    context.loading = loading;
  },
  mutateTokensErrorState(context, error) {
    context.error = error;
  },
  setTokensMetaState(context, meta) {
    context.meta = meta;
  },
  mutateTokensMetaState(context, meta) {
    context.meta = {...context.meta, ...meta};
  }
};
